import { Container, Rectangle } from 'pixi.js';
import { PixiViewportSystem } from 'yage/systems/render/PixiViewport';
import { LOCAL, setPaused } from '../services/local.js';
import { C, button, label, rounded } from './primitives.js';
import { hideWorldOverlays } from './overlays.js';

export class PauseOverlay {
    readonly root = new Container();
    constructor(parent: Container) {
        parent.addChild(this.root);
        this.root.zIndex = 2000;
        this.root.visible = false;
        this.root.eventMode = 'static';
        this.root.on('pointerdown', event => event.stopPropagation());
        LOCAL.onPause = paused => { this.root.visible = paused; hideWorldOverlays(paused || LOCAL.modalOpen); this.paint(); };
        window.addEventListener('resize', this.onResize);
    }
    resize(w: number, h: number) {
        this.root.removeChildren().forEach(child => child.destroy({ children: true }));
        this.root.hitArea = new Rectangle(0, 0, w, h);
        rounded(this.root, 0, 0, w, h, 0, C.dark, .75);
        const width = Math.min(340, w - 32), x = (w - width) / 2, y = Math.max(16, (h - 210) / 2);
        rounded(this.root, x, y, width, 210, 18, C.cream);
        label(this.root, 'PAUSED', x + 24, y + 24, 26, C.navy, '800');
        label(this.root, 'Passengers, flights and work are stopped.', x + 24, y + 72, 15, C.muted, '600', width - 48);
        button(this.root, 'Resume', x + 24, y + 144, width - 48, 44, () => setPaused(false), C.teal);
    }
    private paint() {
        const app = LOCAL.model?.getSystem(PixiViewportSystem)?.pixiApp;
        // YAGE stops its draw loop while paused, so paint this UI change explicitly.
        if (app) app.renderer.render(app.stage);
    }
    private onResize = () => { if (this.root.visible) { this.resize(window.innerWidth, window.innerHeight); this.paint(); } };
    destroy() { window.removeEventListener('resize', this.onResize); LOCAL.onPause = null; this.root.destroy({ children: true }); }
}
